// extracted by mini-css-extract-plugin
export default {"techsContainer":"TechsList_techsContainer__yCIeq"};